//https://cors-anywhere.herokuapp.com/
//export const BASE_URL = 'https://yd1cdyji5f.execute-api.ap-south-1.amazonaws.com';

// Provide a safe ENV source: prefer a runtime-injected `window.ENV` (if your deployment injects it),
// otherwise fall back to environment variables injected at build time by Create React App
// (they must be prefixed with REACT_APP_ to be visible in the browser bundle).
const ENV = (typeof window !== 'undefined' && window.ENV) ? window.ENV
  : {
    DASHBOARD_ADMIN_BASE_URL: process.env.REACT_APP_DASHBOARD_ADMIN_BASE_URL,
    DASHBOARD_CLIENT_BASE_URL: process.env.REACT_APP_DASHBOARD_CLIENT_BASE_URL,
    DASHBOARD_CLIENT_V2_BASE_URL: process.env.REACT_APP_DASHBOARD_CLIENT_V2_BASE_URL,
  };

export const BASE_URL_3 = `${ENV.DASHBOARD_ADMIN_BASE_URL}`;
export const BASE_URL_4 = `${ENV.DASHBOARD_CLIENT_BASE_URL}`;
export const BASE_URL_5 = `${ENV.DASHBOARD_CLIENT_V2_BASE_URL}`;

// const ROUTES = {
//   AUTH: 'auth',
//   GET_GENERS: 'categories',
//   GAMES: 'admin-api',
//   CLIENT: `admin`,
// }

//export const BASE_URL_3 = 'http://13.202.57.144:8082';
//export const BASE_URL_4 = 'http://13.202.57.144:8081';
const ROUTES = {
  AUTH: 'auth',
  GET_GENERS: 'categories',
  ADMIN: 'api/admin/v1',
  CLIENT: `api/admin/v1`,
  CLIENT_V2: `api/client/v1`,
}

const ENDPOINTS = {
  // SIGN_OUT: `${BASE_URL}/${ROUTES.AUTH}/signout`,
  // GET_USERS: `${BASE_URL}/users`,
  // GET_USER: (id) => `${BASE_URL}/users/${id}`,
  // GET_GENERS: `${BASE_URL}/genres`,
  // GET_SUBCATEGORIES: (categoryId) => `${categoryId}/subcategories`,

  /**
   * Question Bank
   */
  GET_QUESTIONS: `${BASE_URL_3}/${ROUTES.ADMIN}/question`,
  UPDATE_QUESTION_STATUS: (questionId) => `${BASE_URL_3}/${ROUTES.ADMIN}/question/edit-status/${questionId}`,
  CREATE_QUESTION: `${BASE_URL_3}/${ROUTES.ADMIN}/question/create`,
  UPDATE_QUESTION: (questionId) => `${BASE_URL_3}/${ROUTES.ADMIN}/question/edit-question/${questionId}`,
  DELETE_QUESTION: (questionId) => `${BASE_URL_3}/${ROUTES.ADMIN}/question/${questionId}`,

  /**
   * Question Bank New
   */
  GET_QUESTION_FILTER_NEW: `${BASE_URL_5}/${ROUTES.CLIENT_V2}/QB-filters`,
  GET_QUESTIONS_NEW: `${BASE_URL_5}/${ROUTES.CLIENT_V2}/get-questionBanks`,   //page,limit,search
  GET_QUESTION_DETAIL_NEW: (questionId) => `${BASE_URL_5}/${ROUTES.CLIENT_V2}/question-detail/${questionId}`,
  GET_VIMEO_OR_CONTENT_ID_DETAIL: `${BASE_URL_4}/${ROUTES.CLIENT}/QB-multimedia`,
  CREATE_QUESTION_NEW: `${BASE_URL_4}/${ROUTES.CLIENT}/QB/create-question`,
  UPDATE_QUESTION_STATUS_NEW: (questionId) => `${BASE_URL_4}/${ROUTES.CLIENT}/QB-update-status/${questionId}`,
  UPDATE_QUESTION_NEW: (questionId) => `${BASE_URL_3}/${ROUTES.ADMIN}/QB/update/${questionId}`,

  /**
   * Games Endpoints
   */
  GET_GAMES: `${BASE_URL_3}/${ROUTES.ADMIN}/games`,
  GET_GAME: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/game/${gameId}`,
  CREATE_GAME: `${BASE_URL_3}/${ROUTES.ADMIN}/game`,
  UPDATE_GAME: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/game/${gameId}`,
  DELETE_GAME: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/game/${gameId}`,
  RELEASE_ANSWER_GAME: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/question/${gameId}/submitAnswer`,

  /**
   * Shows Endpoints
   */
  GET_SHOWS: `${BASE_URL_3}/${ROUTES.ADMIN}/shows`,

  /**
   * Question
   */
  CREATE_QUESTION_BANK: `${BASE_URL_4}/${ROUTES.CLIENT}/get-questionBanks`,

  /**
   * Entity Endpoints
   */
  GET_ARTISTS: `${BASE_URL_3}/${ROUTES.ADMIN}/entity`,
  GET_ENTITY_GLOBALS: `${BASE_URL_3}/${ROUTES.ADMIN}/entity/get_globals`,
  GET_ENTITIES: `${BASE_URL_3}/${ROUTES.ADMIN}/entity`,
  GET_ENTITY: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/entity/details/${gameId}`,
  CREATE_ENTITY: `${BASE_URL_3}/${ROUTES.ADMIN}/entity/create`,
  UPDATE_ENTITY: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/entity/edit/${gameId}`,
  DELETE_ENTITY: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/entity/${gameId}`,

  /**
   * Multimedia Endpoints (Images/Audio/Videos)
   */
  MULTIMEDIA_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/media`,
  MULTIMEDIA_LIST_BY_ENTITY_ID: (entityId) => `${BASE_URL_3}/${ROUTES.ADMIN}/media/detailsByEnityId/${entityId}`,
  MULTIMEDIA_CREATE: `${BASE_URL_3}/${ROUTES.ADMIN}/media/create`,
  MULTIMEDIA_EDIT: (mediaId) => `${BASE_URL_3}/${ROUTES.ADMIN}/media/edit/${mediaId}`,
  MULTIMEDIA_DETAIL: (mediaId) => `${BASE_URL_3}/${ROUTES.ADMIN}/media/details/${mediaId}`,
  MULTIMEDIA_DELETE: (mediaId) => `${BASE_URL_3}/${ROUTES.ADMIN}/media/delete/${mediaId}`,

  /**
   * GAME - Fantasy League Real
   */
  FL_REAL_GAME_DETAILS: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/details/${gameId}`,
  FL_REAL_CREATE_GAME: `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/create-game`,
  FL_REAL_UPDATE_GAME: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/edit-game/${gameId}`,
  FL_REAL_SUBMIT_STATS: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/submitStats/${gameId}`,

  /**
   * Stats - Fantasy League Real
   */
  getStats: `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/getStats`,
  getActiveStatsEntity: `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/getActiveEnt`,
  submitStats: `${BASE_URL_3}/${ROUTES.ADMIN}/FLReal/submitStats`,

  /**
   * Tambola Game
   */
  getTambolaMultimediaList: `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/video-list`,
  getTambolaMultimediaDetail: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/video-detail/${id}`,
  addTambolaMultimediaList: `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/add-video`,
  editTambolaMultimediaList: (multimediaId) => `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/edit-video/${multimediaId}`,
  getTambolaGamesList: `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/game-list`,
  getTambolaGameDetail: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/details/${gameId}`,
  createTambolaGame: `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/create-game`,
  editTambolaGame: (gameId) => `${BASE_URL_3}/${ROUTES.ADMIN}/tambola/edit-game/${gameId}`,

  /**
   * CSV
   */
  pushImportCSVEntity: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/import-csv-entity`,
  pushImportCSVFantasy: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/import-csv-fantacy`,
  pushImportCSVFantasyStats: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/import-csv-fantacy-stats`,
  pushImportCSVHousie: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/import-csv-tambola`,
  processTambolaVideo: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/tambola-video-process`,
  csvBatchList: `${BASE_URL_3}/${ROUTES.ADMIN}/csv/batch-list`,
  csvBatchDetail: (batchId) => `${BASE_URL_3}/${ROUTES.ADMIN}/csv/batch-detail/${batchId}`,
  csvQuestionBank: `${BASE_URL_3}/${ROUTES.ADMIN}/questionBank/create-questionBanks`,
  uploadContentIDSheet: `${BASE_URL_4}/${ROUTES.ADMIN}/csv/import-csv-mm`,

  /**
   * Client User Managment
   */
  clientDeletedUserList: `${BASE_URL_5}/${ROUTES.CLIENT_V2}/user/deleted-users`,
  deleteClientUserFromAWS: (userId) => `${BASE_URL_4}/${ROUTES.CLIENT}/user/admin-delete/${userId}`,

  /**
   * Anchor Cat
   */
  GET_ANCHOR_CATEGORIES: `${BASE_URL_3}/${ROUTES.CLIENT}/user/`,

  /**
    * Currency Transactions
    */
  CURRENCY_TXN_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/currencyTxn`,
  SALES_TXN_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/currencyTxn/sales-transactions`,
  RAPSHORTS_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts`,
  RAPSHORTS_DETAIL: (shortId) => `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts/detail/${shortId}`,
  RAPSHORTS_CREATE: `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts/create`,
  RAPSHORTS_EDIT: (shortId) => `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts/edit/${shortId}`,
  RAPSHORTS_STATUS_UPDATE: (shortId) => `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts/status/${shortId}`,
  RAPSHORTS_DELETE: (shortId) => `${BASE_URL_3}/${ROUTES.ADMIN}/rapshorts/${shortId}`,
  UGC_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/`,
  UGC_APPROVE: (clipId) => `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/approve/${clipId}`,
  UGC_REJECT: (clipId) => `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/reject/${clipId}`,
  UGC_PUBLISH: (clipId) => `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/publish/${clipId}`,
  UGC_STATUS_UPDATE: (clipId) => `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/status/${clipId}`,
  UGC_DETAIL: (clipId) => `${BASE_URL_3}/${ROUTES.ADMIN}/ugc/detail/${clipId}`,

  /**
   * Feedback Forms
   */
  FEEDBACK_FORMS_LIST: `${BASE_URL_3}/${ROUTES.ADMIN}/feedback`,
  FEEDBACK_FORMS_CREATE: `${BASE_URL_3}/${ROUTES.ADMIN}/feedback`,
  FEEDBACK_FORMS_DETAIL: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}`,
  FEEDBACK_FORMS_UPDATE: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}`,
  FEEDBACK_FORMS_DELETE: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}`,
  FEEDBACK_FORMS_PUBLISH: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}/publish`,
  FEEDBACK_FORMS_RESPONSES: (id) => `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}/responses`,
  FEEDBACK_FORMS_RESPONSE_DETAIL: (id, responseId) =>
    `${BASE_URL_3}/${ROUTES.ADMIN}/feedback/${id}/responses/${responseId}`,
  FEEDBACK_PUBLIC_FORM: (slug) => `${BASE_URL_3}/api/public/v1/feedback/${slug}`,
  FEEDBACK_PUBLIC_SUBMIT: (slug) => `${BASE_URL_3}/api/public/v1/feedback/${slug}/submit`,

};

export default ENDPOINTS;